import { render, staticRenderFns } from "./ConfettiParticles.vue?vue&type=template&id=75a433ca"
import script from "./ConfettiParticles.vue?vue&type=script&lang=js"
export * from "./ConfettiParticles.vue?vue&type=script&lang=js"
import style0 from "./ConfettiParticles.vue?vue&type=style&index=0&id=75a433ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports